export default __webpack_public_path__ + "static/media/wipro.f2975fa3.jpg";